import { DropZoneCsv } from './DropZoneCsv';
import { DropZoneFile } from './DropZoneFile';
import { DropZoneImage } from './DropZoneImage';
import type { DropZoneProps } from './types';
export const DropZone = (props: DropZoneProps) => {
  if (props.variant === 'csv') {
    const {
      dropZoneClassName,
      ...csvProps
    } = props;
    return <DropZoneCsv {...csvProps} dropZoneClassName={dropZoneClassName} />;
  }
  if (props.variant === 'image') {
    return <DropZoneImage {...props} />;
  }
  return <DropZoneFile {...props} />;
};